function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useContext, useEffect, useRef } from 'react';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { getAttributeForBrand } from "../../constants";
import GlobalStyle from "./GlobalStyle";
export var BrandContext = /*#__PURE__*/createContext(null);
export function useBrand() {
  return useContext(BrandContext);
}
var injectFonts = function injectFonts(theme) {
  if (!theme.assets || !theme.assets.fonts || typeof document === 'undefined') {
    return;
  }
  var id = "csl-font-faces-".concat(theme.brand);

  // prevent the same fonts being injected twice
  if (document.getElementById(id)) return;
  var fontFaces = theme.assets.fonts;
  var styleTag = document.createElement('style');
  styleTag.id = id;
  styleTag.textContent = fontFaces;
  document.head.appendChild(styleTag);
};

/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/setup/developers)
 **/
var BrandProvider = function BrandProvider(_ref) {
  var _theme$assets;
  var _ref$cssPrefix = _ref.cssPrefix,
    cssPrefix = _ref$cssPrefix === void 0 ? '&&&' : _ref$cssPrefix,
    _ref$ssr = _ref.ssr,
    ssr = _ref$ssr === void 0 ? false : _ref$ssr,
    _ref$testAttributeNam = _ref.testAttributeName,
    testAttributeName = _ref$testAttributeNam === void 0 ? 'data-qa-id' : _ref$testAttributeNam,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {} : _ref$theme,
    children = _ref.children;
  if (theme !== null && theme !== void 0 && theme.alpha) {
    console.warn('This Constellation theme is in Alpha. Please do not use in production.');
  }
  var portalEl = useRef();
  if (typeof document !== 'undefined' && !portalEl.current) {
    var newPortalEl = document.createElement('div');
    document.body.appendChild(newPortalEl);
    portalEl.current = newPortalEl;
  }
  useEffect(function () {
    if (!ssr) injectFonts(theme);
  }, [ssr, theme.brand]);
  var fonts = theme === null || theme === void 0 ? void 0 : (_theme$assets = theme.assets) === null || _theme$assets === void 0 ? void 0 : _theme$assets.fonts;
  return /*#__PURE__*/React.createElement(BrandContext.Provider, {
    value: {
      brand: theme.brand,
      brandTitle: getAttributeForBrand(theme.brand, 'TITLE'),
      portalEl: portalEl.current,
      testAttributeName: testAttributeName
    }
  }, /*#__PURE__*/React.createElement(GlobalStyle, {
    $fonts: fonts,
    $ssr: ssr
  }), /*#__PURE__*/React.createElement(StyleSheetManager, {
    enableVendorPrefixes: true
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: _objectSpread(_objectSpread({}, theme), {}, {
      cssPrefix: cssPrefix
    })
  }, React.Children.toArray(children))));
};
export default BrandProvider;